import { saveActivityTypeFilterGridState as saveActivityTypeFilterGridStateDiagram  } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    columnState: [];
};

export const saveActivityTypeFilterGridState = ({
    columnState,
}: Props) => {
    saveActivityTypeFilterGridStateDiagram(columnState);
};
